const zipValidation = (county, postalCode) => {
  let postalCodeRegex = new RegExp();
  switch (county) {
    case "US":
      postalCodeRegex = new RegExp(/^\d{5}$/i);
      break;
    case "CA":
      postalCodeRegex = new RegExp(
        /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i
      );
  }
  return postalCodeRegex.test(postalCode);
};
export { zipValidation };
